import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress removeChild errors caused by external scripts/extensions
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function(child) {
  if (child.parentNode !== this) {
    console.warn('RemoveChild: node is not a child of this node');
    return child;
  }
  return originalRemoveChild.apply(this, arguments);
};

const originalInsertBefore = Node.prototype.insertBefore;
Node.prototype.insertBefore = function(newNode, referenceNode) {
  if (referenceNode && referenceNode.parentNode !== this) {
    console.warn('InsertBefore: reference node is not a child of this node');
    return newNode;
  }
  return originalInsertBefore.apply(this, arguments);
};

// Global error handler to suppress the removeChild error display
window.addEventListener('error', function(event) {
  if (event.error && event.error.message && event.error.message.includes('removeChild')) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

const container = document.getElementById('root');
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(<App />);
}